<script setup lang="ts">
  const { t } = useI18n();

  usePageHead({
    pageName: t('SALARY_CALCULATOR_PAGE.TITLE'),
    description: t('SALARY_CALCULATOR_PAGE.DESCRIPTION'),
    isMainNavPage: true,
  });
</script>

<template>
  <Calculator mode="salary" />
</template>
